// Decide QUÉ superficies vigilan los deploys de Vercel para ofrecer el botón
// "Actualizar ahora" (components/BuildWatcher.tsx).
//
// El aviso existe para los OPERADORES: tablets POS / KDS / kiosko / display que
// quedan abiertas días enteros sobre el mismo bundle y, sin él, siguen corriendo
// una build vieja tras cada merge a main (2026-07-17: 16 deploys, 249 404s de
// skew). Para un CLIENTE en una página pública el aviso no aporta nada — su
// visita dura minutos y su próxima carga ya trae la build nueva — y en cambio
// interrumpe: aparece encima del carrito en /order/[slug] o del PWA de mesa
// mientras come, y recargar a media orden es justo lo que no queremos.
//
// Por eso el default es NO vigilar: solo se vigila lo que se reconoce como
// superficie de operador. Una página pública nueva nunca hereda el aviso por
// accidente; una pantalla de operador nueva vive bajo /[slug]/... y lo hereda
// sola.
//
// OJO: esto NO desactiva el aviso ante un error real de version skew (un chunk
// que ya no existe). Ese camino se mantiene en TODAS las superficies porque su
// alternativa es una página rota — ver lib/deploy/versionSkew.ts.

// Primeros segmentos de ruta que son de cara al cliente. Todo lo demás con dos
// o más segmentos se trata como superficie de operador.
// Mantener alineado con app/: rutas nuevas de cliente se agregan aquí.
const CUSTOMER_ROOTS = new Set([
  "blog", // /blog/[slug] — marketing
  "buy", // /buy/[eventSlug] — compra de entradas
  "demo", // /demo/[token] — demo de ventas
  "design-system", // /design-system/* — showcase público
  "features", // /features/[slug] — marketing
  "guestlist", // /guestlist/[eventSlug] — registro de invitados
  "help", // /help/[slug] — centro de ayuda
  "m", // /m/table/[token] — PWA de mesa del cliente
  "order", // /order/[slug] — pedidos en línea
  "r", // /r/[slug] — short-link
  "receipt", // /receipt/[orderId] — recibo público
  "reserva", // /reserva/[token] — reserva del cliente
  "review", // /review/[token] — captura de reseña
  "solution", // /solution/[vertical] — marketing
  "venezuela", // /venezuela/* — campaña pública
  "venue", // /venue/[slug] — microsite público
])

/**
 * ¿Esta ruta debe consultar /api/build-id y ofrecer "Actualizar ahora" cuando
 * sube un deployment nuevo?
 *
 * Reglas:
 * - Rutas de un solo segmento (`/`, `/pricing`, `/login`, y el microsite
 *   `/[slug]`) son marketing o visita de cliente → no.
 * - Rutas cuyo primer segmento está en CUSTOMER_ROOTS → no.
 * - El resto (`/[slug]/pos`, `/[slug]/kitchen`, `/[slug]/dashboard`,
 *   `/display/[slug]`, `/superadmin/*`, `/employee/*`, `/onboarding/*`) → sí.
 */
export function watchesDeployments(pathname: string | null | undefined): boolean {
  if (!pathname) return false
  const segments = pathname.split("/").filter(Boolean)
  if (segments.length < 2) return false
  return !CUSTOMER_ROOTS.has(segments[0].toLowerCase())
}
